import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import {FormatedSaleData} from '../../../../../utils/print/GlobelSaleData';
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const InvoiceThumnail6 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser,settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
   const globalData=FormatedSaleData(data);
  const cashRef = useRef();
  const paylaterRef = useRef();

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
    const formatCurrencyINR = (value) => {    
    const formatted = Math.abs(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2  
  });   
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");

  //commercial invoice

  const generateInvoice1 = async () => {
   const doc = new jsPDF("p", "mm", "a4");
   const pageW = doc.internal.pageSize.getWidth();
   const pageH = doc.internal.pageSize.getHeight();
   console.log("data",data)
   const PADDING = 5; 
   const MARGIN_LEFT = PADDING;
   const MARGIN_RIGHT = pageW - PADDING;
   let y = PADDING+5;
 
   // --- 1. HEADER SECTION ---
   // Logo (Top Left)
     const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    // if (imagePath) {
  if (imagePath) {
     try {
        //  const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;
         const base64 = await urlToBase64(imagePath);
 
         // 1. Get real dimensions
         const { width, height } = await loadImageDimensions(base64);
 
         // 2. Define your maximum allowed size for the logo area
         const maxWidth = 30; // Slightly larger for better readability
         const maxHeight = 12;
 
         // 3. Calculate the ratio that fits without squeezing
         const ratio = Math.min(maxWidth / width, maxHeight / height);
         const finalWidth = width * ratio;
         const finalHeight = height * ratio;
 
         // 4. Center the image vertically in the 12-unit high 'maxHeight' space
         const adjustedY = y - 5 + ((maxHeight - finalHeight) / 2);
 
         // 5. Add the image with dynamic dimensions
         doc.addImage(base64, 'PNG', MARGIN_LEFT, adjustedY, finalWidth, finalHeight);
 
     } catch (err) {
         // Fallback: If image fails, show company title
         console.warn("Logo failed to load:", err);
         doc.setFont("Inter-Bold", "bold");
         doc.setFontSize(14);
         doc.text(data?.salefrom?.title || "COMPANY LOGO", MARGIN_LEFT, y);
     }
 }
  
   doc.setFont("Inter-Bold", "bold");
   doc.setFontSize(12);
   doc.setTextColor(20, 40, 100); 
   doc.text("TAX INVOICE", MARGIN_RIGHT, y, { align: "right" });
   y += 5;
   doc.setFontSize(9);
   doc.setTextColor(0);
   doc.text(`Invoice #: ${globalData?.saleno || ""}`, MARGIN_RIGHT, y, { align: "right" });
 
   // --- 2. SELLER DETAILS (Left) ---
   y += 6;
   doc.setFontSize(10);
   doc.setFont("Inter-Bold", "bold");
   doc.text(globalData?.salefrom?.title || "", MARGIN_LEFT, y);
   
   y += 5;
   doc.setFontSize(8);
   doc.text(`GSTIN ${globalData?.salefrom?.gstnumber || ""}`, MARGIN_LEFT, y);
   
   y += 4;
   doc.setFont("Inter-Regular", "normal");
   const sellerAddress = joinAddress(
     globalData?.salefrom?.addressline1,
     globalData?.salefrom?.addressline2,
     globalData?.salefrom?.district,
     globalData?.salefrom?.state,
     globalData?.salefrom?.pincode
   );
   const sellerAddrLines = doc.splitTextToSize(sellerAddress, 70);
   doc.text(sellerAddrLines, MARGIN_LEFT, y);
   
   y += (sellerAddrLines.length * 4);
  const drawBoldLabelNormalValue = (label, value, x, currentY) => {
     // 1. Set to Bold
     doc.setFont("helvetica", "bold"); 
     const labelText = `${label} `; // Removed colon if you want it exactly like the image
     doc.text(labelText, x, currentY);
     
     // 2. Measure the bold text width
     const labelWidth = doc.getTextWidth(labelText);
     
     // 3. Set to Normal
     doc.setFont("helvetica", "normal");
     doc.text(String(value || ""), x + labelWidth, currentY);
 };
   drawBoldLabelNormalValue("Mobile", globalData?.salefrom?.phone, MARGIN_LEFT, y);
 
 if (globalData?.salefrom?.pannumber) {
     y += 4;
     drawBoldLabelNormalValue("PAN", globalData?.salefrom.pannumber, MARGIN_LEFT, y);
 }
 
 if (globalData?.salefrom?.fassi) {
     y += 4;
     drawBoldLabelNormalValue("FSSAI", globalData?.salefrom.fassi, MARGIN_LEFT, y);
 }
 
 if (globalData?.salefrom?.cinnumber) {
     y += 4;
     drawBoldLabelNormalValue("CIN", globalData.salefrom.cinnumber, MARGIN_LEFT, y);
 }
    const hasCustomer = !!globalData?.saleto;
 const hasDate = !!globalData?.saledate;
 const hasSupply = !!globalData?.saleto?.state;
 
  
 
 let hasBillSection = hasCustomer || hasDate || hasSupply;
 const hasShipping =
  globalData.saleto?.shippingAddress &&
  (globalData?.saleto?.shippingAddress?.addressline1 ||
  globalData?.saleto?.shippingAddress?.addressline2 );

const shipColX = 100;      // center column
const rightColX = 160;    // date/time column
 if (hasBillSection) {
   y += 6;
 
  //  const rightColX  = 140; 
   if (hasCustomer) {
     doc.setFont("Inter-Bold", "bold");
     doc.setTextColor(80, 80, 80);
     doc.text("Bill To:", MARGIN_LEFT, y);
 
     doc.setFont("Inter-Bold", "bold");
     doc.setTextColor(0, 0, 0);
     doc.text(globalData?.saleto?.name || "", MARGIN_LEFT, y + 4);
 
     if (globalData?.saleto?.gstnumber) {
       doc.text(`GSTIN: ${globalData.saleto.gstnumber}`, MARGIN_LEFT, y + 8);
     }
 
     // Address
     const custAddress = [
       globalData?.saleto?.addressline1,
       globalData?.saleto?.addressline2,
       globalData?.saleto?.district,
       globalData?.saleto?.state,
       globalData?.saleto?.pincode,
     ]
       .filter(Boolean)
       .join(", ");
 
     let leftY = y + 12;
 
     if (custAddress) {
       const lines = doc.splitTextToSize(custAddress, 80);
       doc.setFont("Inter-Regular", "normal");
       doc.text(lines, MARGIN_LEFT, leftY);
       leftY += lines.length * 4;
     }
 
     // Contact
     if (globalData?.saleto?.phone || globalData?.saleto?.email) {
       const contact = `Ph: ${globalData?.saleto?.phone || ""} ${
         globalData?.saleto?.email ? "| Email: " + globalData?.saleto.email : ""
       }`;
       doc.text(contact, MARGIN_LEFT, leftY);
       leftY += 4;
     }
 
     var leftEndY = leftY;
   }
 /* --- CENTER: SHIPPING ADDRESS --- */
let shipEndY = y;

if (hasShipping) {
  doc.setFont("Inter-Bold", "bold");
  doc.setTextColor(80, 80, 80);
  doc.text("Shipping Address:", shipColX, y);

  const shipAddress = [
    globalData?.saleto?.shippingAddress?.addressline1,
    globalData?.saleto?.shippingAddress?.addressline2,
    globalData?.saleto?.shippingAddress?.district,
    globalData?.saleto?.shippingAddress?.state,
    globalData?.saleto?.shippingAddress?.pincode,
  ]
    .filter(Boolean)
    .join(", ");

  let shipY = y + 4;

  if (shipAddress) {
    const shipLines = doc.splitTextToSize(shipAddress, 50);
    doc.setFont("Inter-Regular", "normal");
    doc.setTextColor(0, 0, 0);
    doc.text(shipLines, shipColX, shipY);

    shipY += shipLines.length * 4;
  }

  shipEndY = shipY;
}
   /* --- RIGHT: DATE / TIME / SUPPLY --- */
   let rightY = y;
 
   if (hasDate) {
     doc.setFont("Inter-Bold", "bold");
     doc.text("Invoice Date:", rightColX , rightY);
 
     doc.setFont("Inter-Regular", "normal");
     doc.text(
       DateConverter.ISOToDisplayFormat(globalData?.saledate).date,
       MARGIN_RIGHT,
       rightY,
       { align: "right" }
     );
 
     rightY += 4;
 
     doc.setFont("Inter-Bold", "bold");
     doc.text("Invoice Time:", rightColX, rightY);
 
     doc.setFont("Inter-Regular", "normal");
     const invTime = DateConverter.ISOToDisplayFormat(
       DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone)
     ).time;
 
     doc.text(invTime, MARGIN_RIGHT, rightY, { align: "right" });
 
     rightY += 4;
   }
 
   if (hasSupply) {
     doc.setFont("Inter-Bold", "bold");
     doc.text("Place of Supply:", rightColX, rightY);
 
     doc.setFont("Inter-Regular", "normal");
     doc.text(globalData?.saleto?.state, MARGIN_RIGHT, rightY, {
       align: "right",
     });
 
     rightY += 4;
   }
 
   /* --- FINAL HEIGHT FIX --- */
   const finalY = Math.max(
  leftEndY || y,
  shipEndY || y,
  rightY
);

 
   y = finalY + 2; 
 }  
    
   autoTable(doc, {
     startY: y,
     theme: "plain",
     margin: {  top: PADDING,  left: PADDING, right: PADDING,  bottom: PADDING,  }, // Balanced 
     styles: { font: "Inter-Regular", fontSize: 8, cellPadding: 2,lineColor: selectedTheme?.templateTheme?.borderColor,  textColor: [0, 0, 0], },
     headStyles: { 
       font: "Inter-Bold", 
       fontStyle: "bold",
       fillColor: false, 
         textColor: "#000",
     //  textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0], // White text
       lineWidth: { bottom: 0.5 }, 
      lineColor: selectedTheme?.templateTheme?.borderColor,
     },
     columnStyles: {
       0: { cellWidth: 10,halign: "left" },
       1: { cellWidth: "auto" },
       2: { cellWidth: 30, halign: "right" },
       3: { cellWidth: 20, halign: "right" },
       4: { cellWidth: 30, halign: "right" },
     },
     head: [["#", "Item", "Selling Price", "Qty", "Amount"]],
     body: globalData.saleitems.map((it, i) => [
       i + 1,
       it.hsnsac ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}` : it.title,
            `₹${it.baseprice}`,
        `${it.quantity} ${
          (() => {
            const unitCode = it?.isSecondaryUnit
              ? (it?.unitConfig?.secondaryUnitCode ||"")
              : (it?.unitConfig?.primaryUnitCode || "");
            return unitCode||"" ;
          })()
        }`,
        `₹${it.lineGrandTotal}`,
     ]),
      didParseCell: function (data) {
         // Header alignment
         if (data.section === "head") {
           const colId = data.column.index;
           if (colId === 0) data.cell.styles.halign = "left";
           if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
             data.cell.styles.halign = "right";
         }
          if (data.section === "body") {
           // Light gray divider lines
           data.cell.styles.lineWidth = { bottom: 0.1 };
         }
       },
   });
 
 y = doc.lastAutoTable.finalY + 5;
 
 
 if (y + PADDING > pageH - 20) {
     doc.addPage();
     y = PADDING + 5; 
 }
 const footerTop = y;
 let leftY = footerTop;
 let rightY = footerTop;
 
 // --- 1. LEFT COLUMN: Bank Details ---
 doc.setFontSize(9);
 doc.setFont("Inter-Bold", "bold");
 doc.setTextColor(0);
  if (storeSettings?.paymentSettings?.bankDetails) {
 doc.text("Bank Details:", MARGIN_LEFT, leftY);
 leftY += 5;
 
 const bankInfo = [
     ["Name:", storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || ""],
     ["Account #:", storeSettings?.paymentSettings?.bankDetails?.accountNo || ""],
     ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
     ["UPI ID:", storeSettings?.paymentSettings?.upiId || ""]
 ];
 
 bankInfo.forEach(([label, value]) => {
     doc.setFont("Inter-Regular", "normal");
     doc.text(label, MARGIN_LEFT, leftY);
     doc.setFont("Inter-Bold", "bold");
     doc.text(String(value || ""), MARGIN_LEFT + 20, leftY);
     leftY += 4;
 });
  }
 const upiId =  storeSettings?.paymentSettings?.upiId || "";
 doc.setFontSize(8);
 doc.setFont("Inter-Bold", "bold");
 doc.setTextColor(0);
 const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "")}&cu=INR`;
   const qrX = pageW / 2 - 15;
   if (upiId && upiId.trim() !== "") {   
     const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, { errorCorrectionLevel: "L", scale: 4, margin: 1 });
     doc.addImage(qrCodeDataUrl, "JPEG", qrX, footerTop-3, 20, 20);
 }
 const summaryX = 140;
 
 // Row 1: Service Charges (Normal Font)
 // doc.setFont("Inter-Regular", "normal");
 // doc.text("Service Charges", summaryX, rightY);
 // doc.setTextColor(0);
 // doc.text(formatCurrency(data.serviceCharges || 0), MARGIN_RIGHT, rightY, { align: "right" });
 // rightY += 4;
 
 // // SAC Code (Small font under Service Charges)
 // doc.setFontSize(7);
 // doc.text("SAC:", summaryX + 10, rightY); // Offset slightly to the right
 // rightY += 5;
 const isInterState = globalData?.salefrom?.statecode && 
                     globalData?.saleto?.statecode && 
                     globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
 
 // Rows 2-4: Taxable & GST (Bold Font)
 const summaryItems = [
     ["Taxable Amount",`₹${globalData.totalbaseprice}` ]];
   if (isInterState) {
     summaryItems.push(["IGST ", `₹${globalData.igstamount}`]);
     } else {
     summaryItems.push(["CGST ",`₹${globalData.cgstamount}`]);
     summaryItems.push(["SGST ", `₹${globalData.sgstamount}`]);
     }
   
 
 doc.setFontSize(9);
 summaryItems.forEach(([label, value]) => {
     doc.setFont("Inter-Regular", "normal");
     doc.setTextColor(0);
     doc.text(label, summaryX, rightY);
     doc.text(value, MARGIN_RIGHT, rightY, { align: "right" });
     rightY += 5;
 });
 rightY+=2
 // --- 4. THE TOTAL BOX ---
 const internalPadding = 2; // Adjust this value to get the exact gap you want
  doc.setFillColor(selectedTheme?.templateTheme?.primaryColor);
 doc.setDrawColor(selectedTheme?.templateTheme?.borderColor,); 
  doc.setTextColor(selectedTheme?.templateTheme?.foregroundColor)  
 doc.setLineWidth(0.4);
 doc.rect(summaryX - 2, rightY - 4, (MARGIN_RIGHT - summaryX) +2, 8, 'FD'); 
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(11);
 doc.text("Total", summaryX, rightY + 1.5);
 doc.text(
     `₹${globalData?.grandtotal || 0}`, 
     MARGIN_RIGHT - internalPadding, // This moves the amount away from the line
     rightY + 1.5, 
     { align: "right" }
 );
  doc.setTextColor(0);
 // doc.text(formatCurrency((CurrencyConverter.toCurrency(data.grandtotal|| 0, "INR")), "INR", true, true), MARGIN_RIGHT, rightY + 1.5, { align: "right" });
 rightY += 8;
 if (leftY  > pageH - 20) {
     doc.addPage();
     leftY = PADDING + 5;
     rightY = PADDING + 5;
 }
  const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);
      
 
 doc.setFontSize(9);
 doc.text("Amount Payable:", summaryX, rightY);
 doc.text(
 `₹${globalData?.balanceDue}`,
   MARGIN_RIGHT,
   rightY,
   { align: "right" }
 );
 rightY += 5;
  doc.setFont("Inter-Regular", "normal");
 doc.text("Amount Paid:", summaryX, rightY);
 doc.text(`${paidamount.toFixed(2)}`,  MARGIN_RIGHT, rightY, { align: "right" });
 doc.setFontSize(8);
 doc.setFont("Inter-Regular", "normal");
 const amountWords = `Total amount (in words) ${globalData?.amountinwords || ""}`;
 // doc.text(amountWords, MARGIN_LEFT, wordsY);
 const wordLines = doc.splitTextToSize(amountWords, qrX +25 ); 
 doc.text(wordLines, MARGIN_LEFT, leftY + 2);
 
 
 leftY += (wordLines.length * 4) + 3;
 

 let paymentMethodsHeight = 0;
 if (globalData?.cashPaid > 0) paymentMethodsHeight += 4;
 if (globalData?.upiPaid > 0) paymentMethodsHeight += 4;
 if (globalData?.cardPaid > 0) paymentMethodsHeight += 4;
 if (globalData?.onlinePaid > 0) paymentMethodsHeight += 4;
 const totalNeededHeight = paymentMethodsHeight + (wordLines.length * 4) + 10;
 if (leftY + totalNeededHeight > pageH - 20) {
     doc.addPage();
     leftY = PADDING + 5;
     rightY = PADDING + 5;
 }
   
const payments = [
  { amount: globalData?.cashPaid, label: "Cash" },
  { amount: globalData?.upiPaid, label: "UPI" },
  { amount: globalData?.cardPaid, label: "Card" },
  { amount: globalData?.onlinePaid, label: "Online" },
].filter(p => p.amount > 0);

const drawPayment = (amount, label, isLast) => {
  if (amount > 0) {
    let x = MARGIN_LEFT;

    //  Bold Amount
    doc.setFont("Inter-Bold", "bold");
    const amountText = `₹${amount} `;
    doc.text(amountText, x, leftY);

    x += doc.getTextWidth(amountText);

    //  Normal Text
    doc.setFont("Inter-Regular", "normal");
    doc.text(`Paid via ${label}`, x, leftY);

    //  ONLY add spacing if NOT last
    if (!isLast) {
      leftY += 4;
    }
  }
};

payments.forEach((p, index) => {
  const isLast = index === payments.length - 1;
  drawPayment(p.amount, p.label, isLast);
});
     doc.setFont("Inter-Regular", "normal");
 
 y = Math.max(leftY, rightY) + 8;
 if (y > pageH - 40) {
     doc.addPage();
     y = PADDING + 5;
 }
 let rowStartY = y; 
 if (terms?.length > 0) {
     doc.setFont("Inter-Bold", "bold");
     doc.setFontSize(9);
     doc.setTextColor(72, 72, 72);
     
     // Page break check
     if (rowStartY > pageH - 25) {
         doc.addPage();
         rowStartY = PADDING + 5;
     }
 
     doc.text("Terms & Conditions", PADDING, rowStartY);
     doc.setTextColor(0);
     doc.setFont("Inter-Regular", "normal");
     doc.setFontSize(7);
 
     const termLines = doc.splitTextToSize(terms, (pageW -50) ); // Limit width to half page
     let currentTermY = rowStartY + 5;
 
     termLines.forEach((line) => {
         if (currentTermY > pageH - 20) {
             doc.addPage();
             currentTermY = 10;
         }
         doc.text(line, PADDING, currentTermY);
         currentTermY += 5; 
     });
     
     // Update global y based on how long the terms were
     y = currentTermY;
 }
 
 if (storeSettings?.invoiceSettings?.signature) {
     try {
         const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
         const base64 = await urlToBase64(signimg);
         const { width, height } = await loadImageDimensions(base64);
         
         const maxWidth = 35;
         const maxHeight = 20;
         const ratio = Math.min(maxWidth / width, maxHeight / height);
         const imgW = width * ratio;
         const imgH = height * ratio;
 
         doc.addImage(
             base64,
             signimg.endsWith(".png") ? "PNG" : "JPEG",
             MARGIN_RIGHT - imgW, 
             rowStartY, // Start at the same Y as the Terms header
             imgW,
             imgH
         );
     } catch {
         console.warn("Signature load failed");
     }
 }
 doc.setTextColor(0);
 doc.setFont("Inter-Regular", "normal");
 doc.setFontSize(10);
 doc.text("Authorized Signatory", MARGIN_RIGHT, rowStartY + 13, {
     align: "right",
 });
     if (storeSettings?.negobillBranding) {
       const y = pageH - 5;
       const rightX = (pageW /2)-10;
 
       // Text parts
       const normalText = "Powered by ";
       const boldText = "NegoBill.com";
 
       doc.setFontSize(8);
 
       // Measure widths
       doc.setFont("Inter-Regular", "normal");
       const normalW = doc.getTextWidth(normalText);
 
       doc.setFont("Inter-Bold", "bold");
 
       // Start X so whole string is right-aligned
       const startX = rightX;
 
       // Draw normal part
       doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX , y, {
       align: "center",
     });
 
       // Draw bold part
       doc.setFont("Inter-Bold", "bold");
        doc.text(boldText, startX+1  + normalW, y, {
       align: "center",
     });
     }
   setDownload(false);
   return doc;
 };

  //A4 bill commercial

  const generateBill1 = async () =>  {
   const doc = new jsPDF("p", "mm", "a4");
   const pageW = doc.internal.pageSize.getWidth();
   const pageH = doc.internal.pageSize.getHeight();
  
   const PADDING = 5; 
   const MARGIN_LEFT = PADDING;
   const MARGIN_RIGHT = pageW - PADDING;
   let y = PADDING+5;
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
   // --- 1. HEADER SECTION ---
   // Logo (Top Left)
  if (imagePath) {
     try {
     
        //  const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;
         const base64 = await urlToBase64(imagePath);
 
         // 1. Get real dimensions
         const { width, height } = await loadImageDimensions(base64);
 
         // 2. Define your maximum allowed size for the logo area
         const maxWidth = 30; // Slightly larger for better readability
         const maxHeight = 12;
 
         // 3. Calculate the ratio that fits without squeezing
         const ratio = Math.min(maxWidth / width, maxHeight / height);
         const finalWidth = width * ratio;
         const finalHeight = height * ratio;
 
         // 4. Center the image vertically in the 12-unit high 'maxHeight' space
         const adjustedY = y - 5 + ((maxHeight - finalHeight) / 2);
 
         // 5. Add the image with dynamic dimensions
         doc.addImage(base64, 'PNG', MARGIN_LEFT, adjustedY, finalWidth, finalHeight);
 
     } catch (err) {
         // Fallback: If image fails, show company title
         console.warn("Logo failed to load:", err);
         doc.setFont("Inter-Bold", "bold");
         doc.setFontSize(14);
         doc.text(data?.salefrom?.title || "COMPANY LOGO", MARGIN_LEFT, y);
     }
 }
  
   doc.setFont("Inter-Bold", "bold");
   doc.setFontSize(12);
   doc.setTextColor(20, 40, 100); 
   doc.text("BILL RECEIPT", MARGIN_RIGHT, y, { align: "right" });
   y += 5;
   doc.setFontSize(9);
   doc.setTextColor(0);
   doc.text(`Bill #: ${data.saleno || ""}`, MARGIN_RIGHT, y, { align: "right" });
 
   // --- 2. SELLER DETAILS (Left) ---
   y += 6;
   doc.setFontSize(10);
   doc.setFont("Inter-Bold", "bold");
   doc.text(data?.salefrom?.title || "", MARGIN_LEFT, y);
   
   y += 5;
   doc.setFontSize(8);
   doc.text(`GSTIN ${data?.salefrom?.gstnumber || ""}`, MARGIN_LEFT, y);
   
   y += 4;
   doc.setFont("Inter-Regular", "normal");
   const sellerAddress = joinAddress(
     data?.salefrom?.addressline1,
     data?.salefrom?.addressline2,
     data?.salefrom?.district,
     data?.salefrom?.state,
     data?.salefrom?.pincode
   );
   const sellerAddrLines = doc.splitTextToSize(sellerAddress, 70);
   doc.text(sellerAddrLines, MARGIN_LEFT, y);
   
   y += (sellerAddrLines.length * 4);
  const drawBoldLabelNormalValue = (label, value, x, currentY) => {
     // 1. Set to Bold
     doc.setFont("helvetica", "bold"); 
     const labelText = `${label} `; // Removed colon if you want it exactly like the image
     doc.text(labelText, x, currentY);
     
     // 2. Measure the bold text width
     const labelWidth = doc.getTextWidth(labelText);
     
     // 3. Set to Normal
     doc.setFont("helvetica", "normal");
     doc.text(String(value || ""), x + labelWidth, currentY);
 };
   drawBoldLabelNormalValue("Mobile", data?.salefrom?.phone, MARGIN_LEFT, y);
 
 if (data?.salefrom?.pannumber) {
     y += 4;
     drawBoldLabelNormalValue("PAN", data.salefrom.pannumber, MARGIN_LEFT, y);
 }
 
 if (data?.salefrom?.fassi) {
     y += 4;
     drawBoldLabelNormalValue("FSSAI", data.salefrom.fassi, MARGIN_LEFT, y);
 }
 
 if (data?.salefrom?.cinnumber) {
     y += 4;
     drawBoldLabelNormalValue("CIN", data.salefrom.cinnumber, MARGIN_LEFT, y);
 }
 
   // --- 3. BILL TO & DATES ---
   y += 6;
   const col2X = 140; // X for dates
   
   // Bill To
   doc.setFont("Inter-Bold", "bold");
   doc.setTextColor(80, 80, 80);
   doc.text("Bill To:", MARGIN_LEFT, y);
     doc.setTextColor(0,0,0);
   // Dates Labels
   doc.text("Bill Date:", col2X, y);
   doc.setFont("Inter-Regular", "normal");
   doc.text(DateConverter.ISOToDisplayFormat(data?.saledate).date, MARGIN_RIGHT, y, { align: "right" });
     const invDateTime = DateConverter.ISOToDisplayFormat(
                                           DateConverter.convertToTimeZone(
                                             data?.saledate,
                                             isUser.timezone,
                                           ),
                                         ).time
   y += 4;
   doc.setFont("Inter-Bold", "bold");
   doc.text(data?.saleto?.name || "", MARGIN_LEFT, y);
   doc.text("BIll Time:", col2X, y);
   doc.setFont("Inter-Regular", "normal");
   doc.text(invDateTime, MARGIN_RIGHT, y, { align: "right" });
 
   y += 4;
    doc.setFont("Inter-Bold", "bold");
   doc.text(`GSTIN: ${data?.saleto?.gstnumber || ""}`, MARGIN_LEFT, y);
   doc.setFont("Inter-Bold", "bold");
   doc.text("Place of Supply:", col2X, y);
   doc.setFont("Inter-Regular", "normal");
   doc.text(data?.saleto?.state || "-", MARGIN_RIGHT, y, { align: "right" });
 
   y += 4;
   const custAddress = [data?.saleto?.addressline1, data?.saleto?.addressline2, data?.saleto?.district, data?.saleto?.state, data?.saleto?.pincode].filter(Boolean).join(", ");
   const custAddrLines = doc.splitTextToSize(custAddress, 80);
   doc.text(custAddrLines, MARGIN_LEFT, y);
   y += (custAddrLines.length * 4);
   const contactInfo = `Ph: ${data?.saleto?.phone || ""} | Email: ${data?.saleto?.email || ""}`;
 
 doc.text(contactInfo, MARGIN_LEFT, y);
   // doc.text(`Ph: ${data?.saleto?.phone || ""}`, MARGIN_LEFT, y);
   // y += 4;
   // doc.text(data?.saleto?.email || "", MARGIN_LEFT, y);
 
 
   y += 2;
   autoTable(doc, {
     startY: y,
     theme: "plain",
     margin: {  top: PADDING,  left: PADDING, right: PADDING,  bottom: PADDING,  }, // Balanced 
     styles: { font: "Inter-Regular", fontSize: 8, cellPadding: 2,lineColor: selectedTheme?.templateTheme?.borderColor,  textColor: [0, 0, 0], },
     headStyles: { 
       font: "Inter-Bold", 
       fontStyle: "bold",
       fillColor: false, 
         textColor: "#000",
     //  textColor: selectedTheme?.templateTheme?.foregroundColor || [0, 0, 0], // White text
       lineWidth: { bottom: 0.5 }, 
      lineColor: selectedTheme?.templateTheme?.borderColor,
     },
     columnStyles: {
       0: { cellWidth: 10,halign: "left" },
       1: { cellWidth: "auto" },
       2: { cellWidth: 30, halign: "right" },
       3: { cellWidth: 20, halign: "right" },
       4: { cellWidth: 30, halign: "right" },
     },
     head: [["#", "Item", "Selling Price", "Qty", "Amount"]],
     body: data.saleitems.map((it, i) => [
       i + 1,
       it.title,
       formatCurrency((CurrencyConverter.toCurrency(it.baseprice|| 0, "INR")), "INR", true, true),
       it.quantity,
       formatCurrency((CurrencyConverter.toCurrency(it.lineGrandTotal|| 0, "INR")), "INR", true, true),
     ]),
      didParseCell: function (data) {
         // Header alignment
         if (data.section === "head") {
           const colId = data.column.index;
           if (colId === 0) data.cell.styles.halign = "left";
           if (colId === 2 || colId === 3 || colId === 4 || colId === 5)
             data.cell.styles.halign = "right";
         }
          if (data.section === "body") {
           // Light gray divider lines
           data.cell.styles.lineWidth = { bottom: 0.1 };
         }
       },
   });
 
 y = doc.lastAutoTable.finalY + 5;
 if (y + PADDING > pageH - 20) {
     doc.addPage();
     y = PADDING + 5; 
 }
 const footerTop = y;
 
 let leftY = footerTop;
 let rightY = footerTop;
 
 // --- 1. LEFT COLUMN: Bank Details ---
 doc.setFontSize(9);
 doc.setFont("Inter-Bold", "bold");
 doc.setTextColor(0);
  if (storeSettings?.paymentSettings?.bankDetails) {
 doc.text("Bank Details:", MARGIN_LEFT, leftY);
 leftY += 5;
 
 const bankInfo = [
     ["Name:", storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || ""],
     ["Account #:", storeSettings?.paymentSettings?.bankDetails?.accountNo || ""],
     ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
     ["UPI ID:", storeSettings?.paymentSettings?.upiId || ""]
 ];
 
 bankInfo.forEach(([label, value]) => {
     doc.setFont("Inter-Regular", "normal");
     doc.text(label, MARGIN_LEFT, leftY);
     doc.setFont("Inter-Bold", "bold");
     doc.text(String(value || ""), MARGIN_LEFT + 20, leftY);
     leftY += 4;
 });
  }
 const upiId =  storeSettings?.paymentSettings?.upiId || "";
 doc.setFontSize(8);
 doc.setFont("Inter-Bold", "bold");
 doc.setTextColor(0);
 const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "")}&cu=INR`;
   const qrX = pageW / 2 - 15;
   if (upiId && upiId.trim() !== "") {   
     const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, { errorCorrectionLevel: "L", scale: 4, margin: 1 });
     doc.addImage(qrCodeDataUrl, "JPEG", qrX, footerTop-3, 20, 20);
 }
 const summaryX = 140;
 // Rows 2-4: Taxable & GST (Bold Font)
 const summaryItems = [
     ["Taxable Amount",  formatCurrency((CurrencyConverter.toCurrency(data.totalbaseprice|| 0, "INR")), "INR", true, true)]];
   
 
 doc.setFontSize(9);
 summaryItems.forEach(([label, value]) => {
     doc.setFont("Inter-Bold", "bold");
     doc.setTextColor(0);
     doc.text(label, summaryX, rightY);
     doc.text(value, MARGIN_RIGHT, rightY, { align: "right" });
     rightY += 5;
 });
 rightY+=2
 // --- 4. THE TOTAL BOX ---
 doc.setFillColor(240, 245, 255); 
 doc.setDrawColor(selectedTheme?.templateTheme?.borderColor,);   
 doc.setLineWidth(0.4);
 doc.rect(summaryX - 2, rightY - 4, (MARGIN_RIGHT - summaryX) + 2, 8, 'FD'); 
 
 doc.setFont("Inter-Bold", "bold");
 doc.setFontSize(11);
 doc.text("Total", summaryX, rightY + 1.5);
 doc.text(
     formatCurrency((CurrencyConverter.toCurrency(data.grandtotal || 0, "INR")), "INR", true, true), 
     MARGIN_RIGHT - 2, // This moves the amount away from the line
     rightY + 1.5, 
     { align: "right" }
 );
 rightY += 8;
 
 
 doc.setFontSize(9);
 doc.text("Amount Payable:", summaryX, rightY);
 doc.text(
   formatCurrency(
     CurrencyConverter.toCurrency(
       (data.grandtotal || 0) - (data.paidamount || 0),
       "INR"
     ),
     "INR",
     true,
     true
   ),
   MARGIN_RIGHT,
   rightY,
   { align: "right" }
 );
 rightY += 5;
 doc.text("Amount Paid:", summaryX, rightY);
 doc.text(formatCurrency(CurrencyConverter.toCurrency(data.paidamount|| 0, "INR"), "INR", true, true), MARGIN_RIGHT, rightY, { align: "right" });
 doc.setFontSize(8);
 doc.setFont("Inter-Regular", "normal");
 const amountWords = `Total amount (in words) ${data?.amountinwords || ""}`;
 // doc.text(amountWords, MARGIN_LEFT, wordsY);
 const wordLines = doc.splitTextToSize(amountWords, qrX +25 ); 
 doc.text(wordLines, MARGIN_LEFT, leftY + 2);
 
 
 leftY += (wordLines.length * 4) + 3;
 
 const cashPaid = (data?.cashamount || 0) - (data?.cashchange || 0);
 const cardPaid = (data?.cardamount || 0) - (data?.cardchange || 0);
 const onlinePaid = (data?.onlineamount || 0) - (data?.onlinechange || 0);
 const upiPaid = (data?.upiamount || 0) - (data?.upichange || 0);
 let paymentMethodsHeight = 0;
 if (cashPaid > 0) paymentMethodsHeight += 4;
 if (upiPaid > 0) paymentMethodsHeight += 4;
 if (cardPaid > 0) paymentMethodsHeight += 4;
 if (onlinePaid > 0) paymentMethodsHeight += 4;
 const totalNeededHeight = paymentMethodsHeight + (wordLines.length * 4) + 10;
 if (leftY + totalNeededHeight > pageH - 20) {
     doc.addPage();
     leftY = PADDING + 5;
     rightY = PADDING + 5;
 }
 doc.setFont("Inter-Bold", "bold");
 if (cashPaid > 0) {
       const cashText = `${formatCurrency((CurrencyConverter.toCurrency(cashPaid|| 0, "INR")), "INR", true, true)} Paid via Cash `;
       doc.text(cashText, MARGIN_LEFT, leftY, { align: "left" });
 
     }
      if (upiPaid > 0) {
        leftY += 4;
       const cashText = `${formatCurrency((CurrencyConverter.toCurrency(upiPaid|| 0, "INR")), "INR", true, true)} Paid via UPI `;
       doc.text(cashText, MARGIN_LEFT, leftY, { align: "left" });
   
     }
      if (cardPaid > 0) {
        leftY += 4;
       const cashText = `${formatCurrency((CurrencyConverter.toCurrency(cardPaid|| 0, "INR")), "INR", true, true)} Paid via card `;
       doc.text(cashText, MARGIN_LEFT, leftY, { align: "left" });
   
     }
  if (onlinePaid > 0) {
    leftY += 4;
       const cashText = `${formatCurrency((CurrencyConverter.toCurrency(onlinePaid|| 0, "INR")), "INR", true, true)} Paid via Online `;
       doc.text(cashText, MARGIN_LEFT, leftY, { align: "left" });
   
     }
     doc.setFont("Inter-Regular", "normal");
 
 y = Math.max(leftY, rightY) + 8;
 if (y > pageH - 40) {
     doc.addPage();
     y = PADDING + 5;
 }
 let rowStartY = y; 
 if (terms?.length > 0) {
     doc.setFont("Inter-Bold", "bold");
     doc.setFontSize(9);
     doc.setTextColor(72, 72, 72);
     
     // Page break check
     if (rowStartY > pageH - 25) {
         doc.addPage();
         rowStartY = PADDING + 5;
     }
 
     doc.text("Terms & Conditions", PADDING, rowStartY);
     doc.setTextColor(0);
     doc.setFont("Inter-Regular", "normal");
     doc.setFontSize(7);
 
     const termLines = doc.splitTextToSize(terms, (pageW -50) ); // Limit width to half page
     let currentTermY = rowStartY + 5;
 
     termLines.forEach((line) => {
         if (currentTermY > pageH - 20) {
             doc.addPage();
             currentTermY = 10;
         }
         doc.text(line, PADDING, currentTermY);
         currentTermY += 5; 
     });
     
     // Update global y based on how long the terms were
     y = currentTermY;
 }
 
 if (storeSettings?.invoiceSettings?.signature) {
     try {
         const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
         const base64 = await urlToBase64(signimg);
         const { width, height } = await loadImageDimensions(base64);
         
         const maxWidth = 35;
         const maxHeight = 20;
         const ratio = Math.min(maxWidth / width, maxHeight / height);
         const imgW = width * ratio;
         const imgH = height * ratio;
 
         doc.addImage(
             base64,
             signimg.endsWith(".png") ? "PNG" : "JPEG",
             MARGIN_RIGHT - imgW, 
             rowStartY, // Start at the same Y as the Terms header
             imgW,
             imgH
         );
     } catch {
         console.warn("Signature load failed");
     }
 }
 doc.setTextColor(0);
 doc.setFont("Inter-Regular", "normal");
 doc.setFontSize(10);
 doc.text("Authorized Signatory", MARGIN_RIGHT, rowStartY + 13, {
     align: "right",
 });
     if (storeSettings?.negobillBranding) {
       const y = pageH - 5;
       const rightX = (pageW /2)-10;
 
       // Text parts
       const normalText = "Powered by ";
       const boldText = "NegoBill.com";
 
       doc.setFontSize(8);
 
       // Measure widths
       doc.setFont("Inter-Regular", "normal");
       const normalW = doc.getTextWidth(normalText);
 
       doc.setFont("Inter-Bold", "bold");
 
       // Start X so whole string is right-aligned
       const startX = rightX;
 
       // Draw normal part
       doc.setFont("Inter-Regular", "normal");
      doc.text(normalText, startX , y, {
       align: "center",
     });
 
       // Draw bold part
       doc.setFont("Inter-Bold", "bold");
        doc.text(boldText, startX+1  + normalW, y, {
       align: "center",
     });
     }
   setDownload(false);
   return doc;
 };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBill1();
    } else {
      doc = await generateInvoice1();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBill1();
      } else {
        doc = await generateInvoice1();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

 
   const formatCurrency2 = (value) => {
     const amount = CurrencyConverter.toCurrency(value, "INR");
     const formatted = Math.abs(amount).toLocaleString('en-IN', {
     minimumFractionDigits: 0, // Don't force .00
     maximumFractionDigits: 2  // Show up to 2 decimals if they exist (like .78)
   }); 
   
     return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
   };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);

 
       useEffect(() => {
          const upi = storeSettings?.paymentSettings?.upiId;
      
          const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
          if (!upi) return; // skip until upi is available
      
          const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
          console.log("ip",upiUrl)
          QRCode.toDataURL(upiUrl)
            .then((url) => {
              setQrCodeDataUrl(url);
            })
            .catch((err) => {
              console.error("QR Code generation failed: ", err);
            });
        }, [storeSettings?.paymentSettings?.upiId, storeSettings?.paymentSettings?.bankDetails?.beneficiaryName]);
          const actualPaidAmount=globalData?.grandtotal  - globalData?.balanceDue;
  
  return (
    <>
      <div className="invoice-scale">
        {globalData.salemode === "INVOICE" ? (
                    <div className="tm_container">
                      <div className="tm_invoice_wrap">
                        <div className="tm_invoice tm_style1 tm_type1">
                          <div className="tm_invoice_in">
                            <div className="d-flex justify-content-between mb-2">
                         <div className="tm_logo text-start">
                                      {globalData?.salefrom?.image && (
                                        <img
                                         src={
                              settings?.saleProfileData?.image
                                ? uRLs.IMAGE_URL +
                                  "profile/" +
                                  settings?.saleProfileData?.image
                                : "/assets/images/logo-light.png"
                            }
                                          className="img-rounded logo mb-0"
                                          height="45"
                                          width="150"
                                          style={{ objectFit: "contain" }}
                                        />
                                      )}
                                    </div>
                                  <div>
                                 <div className="">
                                  TAX INVOICE
                                  <div>
                                   
                                      <span className="fw-600"globalData>Invoice #:</span>{""}
                                      <strong className="font-12">{globalData.saleno}</strong>
                                    </div>
                                 </div>
                                  </div>
                                  </div>
                            <div className="row">
                              <div className="col-7 pe-1 ">                               
                                  <div className="d-flex gap-2 align-items-start">
                                   
                                    <div>
                                      <div
                                        style={{
                                          fontSize: "17px",
                                          fontWeight: "600",
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {globalData?.salefrom?.title || ""}
                                      </div>
                                      {globalData?.salefrom?.gstnumber && (
                                      <div
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          marginBottom: "0px",
                                        }}
                                      >
                                         <>GSTIN:</>{" "}
                                          {globalData?.salefrom?.gstnumber || ""}
                                      </div>)}
                                      <div>
                                        {globalData?.salefrom?.addressline1 || ""}{" "}
                                        {globalData?.salefrom?.addressline2 ||""}{" "}
                                        {globalData?.salefrom?.district || ""}{", "}
                                        {globalData?.salefrom?.state || ""}{", "}
                                        {globalData?.salefrom?.pincode || ""}
                                      </div>
                                        <div>
                                      <strong>Mobile:</strong> {globalData?.salefrom?.phone || ""} | <strong>Email:</strong> {globalData?.salefrom?.email || "-"}
                                    </div>
                                     {globalData?.salefrom?.pannumber && (
                                        <div>
                                          <strong>PAN:</strong>{" "}
                                          {globalData?.salefrom?.pannumber || ""}
                                        </div>
                                      )}
                                       {globalData?.salefrom?.fassi && (
                                        <div>
                                          <strong>FASSI:</strong>{" "}
                                          {globalData?.salefrom?.fassi || ""}
                                        </div>
                                      )}
                                     {globalData?.salefrom?.cinnumber && (
                                      <div>
                                       <strong>CIN:</strong> {globalData?.salefrom?.cinnumber}
                                      </div> )}
                                      
                                   
                                    
                                    </div>
                                  </div>
                              </div>
                           </div>
                            <div className="row mt-2">
                              <div className="col-5 pe-1">
                                {globalData?.saleto &&(<>
                                  <div>
                                    <div style={{
                                      marginBottom:"3px"
                                    }}>
                                      <span className="fw-500">Bill To:</span>{""}
                                                                         </div>
                                                                        <div className="font-12 mb-0"
                                    
                                    >
                                      <strong>{globalData?.saleto?.name || ""}</strong>
                                    </div>
                                    <div>
                                      {globalData?.saleto?.addressline1 || ""}{" "}
                                      {globalData?.saleto?.addressline2 || ""}{" "}
                                    </div>
                                    <div>
                                      {globalData?.saleto?.state || ""}{" "}
                                      {globalData?.saleto?.district || ""}{" "}
                                      {globalData?.saleto?.country || ""}{" "}
                                      {globalData?.saleto?.pincode || ""}
                                    </div>
                                      {/* {globalData?.saleto?.gstnumber && ( */}
                                      <div>
                                        <strong>GSTIN:</strong>{" "}
                                        {globalData?.saleto?.gstnumber || ""}
                                      </div>
                                    {/* )} */}
                                    <div>
                                      {" "}
                                       Ph: {globalData?.saleto?.phone || ""} | Email: {globalData?.saleto?.email || ""}
                                    
                                    </div>
                                    {/* <div> Email {globalData.saleto?.email || ""}</div> */}
                                  
                                    {globalData?.saleto?.pannumber && (
                                      <div>
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.saleto?.pannumber || ""}
                                      </div>
                                    )}
                                    {globalData?.saleto?.cinnumber && (
                                    <div>
                                      <strong>CIN :</strong>{globalData?.saleto?.cinnumber || ""}
                                    </div>
                                    )}
                                    
                                  </div>
                                  </>)}
                              </div>
                                {globalData.saleto?.shippingAddress &&
                           (globalData.saleto?.shippingAddress?.addressline1 ||
                            globalData.saleto?.shippingAddress?.addressline2 ) && (
                       <>
                              <div className="col-5 pe-1">
                             <div
                          style={{
                            fontSize: "12px",
                            // fontWeight: "600",
                            marginBottom: "2px",
                          }}
                        >
                          Shipping Address
                        </div>                    
                        <div>
                          {globalData?.saleto?.shippingAddress?.addressline1 || ""}{" "}
                          {globalData?.saleto?.shippingAddress?.addressline2 || ""}{" "}
                        </div>
                        <div>
                          {globalData?.saleto?.shippingAddress?.state || ""}{" "}
                          {globalData?.saleto?.shippingAddress?.district || ""}{" "}
                          {globalData?.saleto?.shippingAddress?.country || ""} -{" "}
                          {globalData?.saleto?.shippingAddress?.pincode || ""}
                        </div>
                              </div>
                              </>)}
 <div className="col-2 ps-1">
  {saleTime.date &&(<>
  {/* justify-content-between pushes the value to the right end */}
  <div className="d-flex justify-content-between mb-0" style={{ fontSize: "12px" }}>
    <span className="fw-bold">Invoice Date:</span>
    <strong className="fw-semibold">{saleTime.date}</strong>
  </div>

  <div className="d-flex justify-content-between mb-0" style={{ fontSize: "12px" }}>
    <span className="fw-bold">Invoice Time:</span>
    <strong className="fw-semibold">
      {DateConverter.ISOToDisplayFormat(
        DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone)
      ).time}
    </strong>
  </div>
</>)}
  <div className="d-flex justify-content-between mb-10" style={{ fontSize: "12px" }}>
    <span className="fw-bold">Place of Supply:</span>
    <strong className="fw-semibold text-end">
      {globalData?.salefrom?.state || ""}
    </strong>
  </div>
</div>
                            </div>



                            <table
                              // className="items"
                              width="100%"
                              style={{
                                marginTop: "2px",
                                borderCollapse: "collapse",
                                // borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                // borderBottom: "1px solid #000"
                              }}
                              cellPadding="4"
                            >
                              <thead>
                                <tr 
                                //  style={{
                                //   borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                //   borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                                // }}
                                >
                                  <th
                                      className="force-style p-1 fw-bold"
                                    style={{
                                      width: "20px",
                                      textAlign: "left",                                     
                                    }}
                                  >
                                    #
                                  </th>
                                  <th
                                      className="force-style p-1 fw-bold"
                                    style={{
                                      // width: "240px",
                                      textAlign: "left",                                     
                                    
                                    }}
                                  >
                                    Item
                                  </th>
                                
                                  <th
                                     className="force-style p-1 fw-bold"
                                    style={{
                                      width: "50px",
                                      textAlign: "right",                                     
                                    // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    MRP
                                  </th>
                                  <th
                                    className="force-style p-1 fw-bold"
                                    style={{
                                      width: "100px",
                                      textAlign: "right",                                    
                                    
                                      // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    Selling Price
                                  </th>
                                  <th
                                   className="force-style p-1 fw-bold"
                                    style={{
                                      width: "100px",
                                      textAlign: "right",
                                      
                                      // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    Qty
                                  </th>
                                 
                                  <th
                                     className="force-style p-1 fw-bold"
                                    style={{
                                      width: "100px",
                                      textAlign: "right",                                  
                                     
                                      // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    }}
                                  >
                                    Amount
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {globalData?.saleitems?.map((product, index) => (
                                  <tr key={index} style={{
                                    borderTop: `1px solid ${selectedTheme?.templateTheme?.borderColor} `,
                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`
                                  }}>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "left",
                                        fontSize: "12px",
                                        // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {index + 1}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "left",
                                        fontSize: "12px",
                                        width: "53%",
                                        // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      <div>{product.title}</div>
                                      {/* {product.imode === "SERVICE" && (
                                      <div className="ms-0 fsz-10 lh-13 mb-1">
                                        {product.description}
                                      </div>
                                    )} */}
                                      {/* {product.imode === "PRODUCT" &&
                                        product.note && (
                                          <div className="ms-0 fsz-10 mb-1">
                                            {product?.note}
                                          </div>
                                        )} */}
                                      {product.hsnsac && (
                                      <div>
                                        <span className="fw-medium">
                                          {" "}
                                          {product.imode === "SERVICE" ? "SAC:" : "HSN:"}
                                        </span>{" "}
                                        {product.hsnsac}
                                      </div>
                                    )}
                                 
                                    </td>                                  
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >                                     
                                      {formatCurrency((CurrencyConverter.toCurrency(
                                        product?.mrp || 0,"INR")),
                                        "INR",true,true
                                      )}
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                       {formatCurrency((CurrencyConverter.toCurrency(product?.baseprice || 0, "INR")), "INR", true, true)}
                                                                    
                                    </td>
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {`${product?.quantity}`} {
                                          (() => {
                                            const unitCode = product?.isSecondaryUnit
                                              ? (product?.unitConfig?.secondaryUnitCode ||"")
                                              : (product?.unitConfig?.primaryUnitCode || "");
                                            return unitCode||"" ;
                                          })()
                                        }
                                    </td>                                   
                                    <td
                                      className="force-style"
                                      style={{
                                        textAlign: "right",
                                        fontSize: "12px",
                                        // "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                      }}
                                    >
                                      {formatCurrency((CurrencyConverter.toCurrency(product?.lineGrandTotal || 0, "INR")), "INR", true, true)}
                                        
                                    
                                    </td>
                                  </tr>
                                ))}
                              
                              
                              </tbody>
                            </table>
<div className="row mt-2"> 
  <div className="col-5 pe-1">
    <div style={{ fontSize: "13px" }}>
  <strong className="mb-1">Bank Details:</strong><br />

  <div className="d-flex">
    <span style={{ width: "120px" }}>Name:</span>
    <strong>
      {storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || ""}
    </strong>
  </div>

  <div className="d-flex">
    <span style={{ width: "120px" }}>Account #:</span>
    <strong>
      {storeSettings?.paymentSettings?.bankDetails?.accountNo || ""}
    </strong>
  </div>

  <div className="d-flex">
    <span style={{ width: "120px" }}>IFSC:</span>
    <strong>
      {storeSettings?.paymentSettings?.bankDetails?.ifsc || ""}
    </strong>
  </div>

  <div className="d-flex">
    <span style={{ width: "120px" }}>UPI ID:</span>
    <strong>
      {storeSettings?.paymentSettings?.upiId || ""}
    </strong>
  </div>

  <div className="mt-2">
     {`Total amount (in words) ${globalData?.amountinwords || ""}`}
   
  </div>
  <div className=" font-11">
                                    
                            {globalData?.cashPaid > 0 && (
                              <div className=" font-10 ">
                                <span><b>₹{globalData.cashPaid}</b> Paid via Cash</span>
                              </div>
                            )}
                            {globalData?.upiPaid > 0 && (
                              <div className=" font-10 ">
                                <span><b>₹{globalData.upiPaid}</b> Paid via UPI </span>
                              </div>
                            )}
                            {globalData?.cardPaid > 0 && (
                              <div className=" font-10">
                                <span><b>₹{globalData.cardPaid}</b> Paid via Card </span>
                              </div>
                            )}
                            {globalData?.onlinePaid > 0 && (
                              <div className=" font-10 ">
                                <span><b>₹{globalData.onlinePaid}</b> Paid via Online </span>
                              </div>
                            )}
                         
                                  </div>
</div>
    </div>

  {/* CENTER – QR CODE */}
  <div className="col-3 pe-1 text-center">
     {storeSettings?.paymentSettings?.upiId && (  
       <img
                            src={qrCodeDataUrl}
                            alt="QR Code"
                            style={{
                              width: "90px",
                              height: "90px",
                            }}
                          />
                            )}
  </div>

    <div className="col-4 pe-1">
    <div style={{ fontSize: "13px" }}>
      <div className="d-flex justify-content-between ">
        <span>Taxable Amount</span>
      <span>
    ₹{globalData?.totalbaseprice}
        {" "}</span>
      </div>
       {globalData?.salefrom?.statecode &&
                                    globalData?.saleto?.statecode &&
                                    globalData?.salefrom?.statecode !==
                                      globalData?.saleto?.statecode ? (
 <div className="d-flex justify-content-between ">
        <span>IGST</span>
        <span> 
           ₹{globalData?.igstamount}  
           {" "}</span>
      </div>):(<>
      <div className="d-flex justify-content-between ">
        <span>CGST</span>
        <span> 
             ₹{globalData?.cgstamount}
         {" "}</span>
      </div>

      <div className="d-flex justify-content-between ">
        <span>SGST</span>
         <span> 
          ₹{globalData?.sgstamount}
          {" "}</span>
      </div></>
                  )}
     <div
  className="d-flex justify-content-between fw-bold mt-2"
  style={{
                                           backgroundColor: selectedTheme?.templateTheme?.primaryColor,  // light grey/blue
    padding: "6px 10px",
        border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
    borderRadius: "0px"
  }}
>
  <span style={{ color: selectedTheme?.templateTheme?.foregroundColor,}}>Total</span>
  <span style={{ color: selectedTheme?.templateTheme?.foregroundColor,}}>
    ₹{globalData?.grandtotal} 
   
  </span>
</div>
      <div className="d-flex justify-content-between fw-bold">
        <span>Amount Payable:</span>
      <span >
          ₹{globalData?.balanceDue || 0}
 </span>
      </div>
         <div className="d-flex justify-content-between ">
        <span>Amount paid:</span>
      <span>
            ₹{parseFloat(actualPaidAmount || 0).toFixed(2)}
</span>
      </div>
    </div>
  </div>
</div>












                            





 <div className="row mt-2">
  <div className="col-9 pe-1">
                            {terms?.length > 0 && (
                              <table width="100%">
                                <tbody>
                                                                 <tr>
                                    <td
                                      style={{
                                        padding: "8px",
                                      }}
                                      width="100%"
                                    >
                                      <div
                                        className="fs-13 fw-600"
                                        style={{
                                          textAlign: "left",
                                          color: "black",
                                        }}
                                      >
                                        Terms & Conditions
                                      </div>
                                      <div className="terms-box">{terms}</div>
                                    </td>
                                    
                                  </tr>
                                </tbody>
                              </table>
                            )}
                            </div>
                              <div className="col-3 pe-1">
                                   <div>
                                        {storeSettings?.invoiceSettings
                                          ?.signature && (
                                          <div className="text-end p-0 fw-bold ">
                                            <img
                                              src={
                                                uRLs.IMAGE_URL +
                                                storeSettings?.invoiceSettings
                                                  ?.signature
                                              }
                                              width={130}
                                            />
                                          </div>
                                        )}
                                        <div className="text-end p-0">
                                          Authorized Signatory
                                        </div>
                                        {/* <div className="text-end p-0 fw-bold font-14">
                                          {globalData?.salefrom?.title}
                                        </div> */}
                                      </div>
                                </div>
                  </div>
                             {storeSettings?.negobillBranding &&(
              <div className="d-flex justify-content-center"> <span>Powered by <strong>NegoBill.com</strong></span></div>)}
                         
                          
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : globalData?.salemode === "BILL" ? (
                     <div className="tm_container">
                      <div className="tm_invoice_wrap">
                        <div className="tm_invoice tm_style1 tm_type1">
                         
                        </div>
                      </div>
                    </div>
                  ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"} />
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoiceThumnail6;
